import React, { useEffect } from 'react';
import './Career.css';
import {
    Briefcase,
    Clock,
    Award,
    TrendingUp,
    Trophy,
    Mail,
    Phone,
    CheckCircle2,
    Calendar,
    FileText,
    UserCheck,
    Smile
} from 'lucide-react';

const Career = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const steps = [
        { title: "Sending Resume", icon: <FileText size={20} /> },
        { title: "Review Resume", icon: <UserCheck size={20} /> },
        { title: "Schedule Interview", icon: <Calendar size={20} /> },
        { title: "Interview", icon: <Briefcase size={20} /> },
        { title: "Result", icon: <CheckCircle2 size={20} /> },
        { title: "Joining", icon: <Smile size={20} /> },
    ];

    return (
        <div className="cr-premium-page">

            {/* Hero Section */}
            <div className="cr-hero">
                <div className="cr-hero-overlay"></div>
                <div className="cr-hero-content">
                    <span className="cr-hero-badge">Join Our Team</span>
                    <h1 className="cr-hero-title">Shape Your Future With Us</h1>
                    <p className="cr-hero-subtitle">
                        Be part of a mission-driven team empowering farmers with technology and nature's wisdom.
                    </p>
                </div>
            </div>

            <div className="cr-container">

                {/* Benefits Section */}
                <div className="cr-section">
                    <h2 className="cr-section-title">Why Work at Amaravathi Naturo Tech pvt ltd?</h2>
                    <p className="cr-section-desc">Benefits designed to support your growth and well-being.</p>

                    <div className="cr-benefits-grid">
                        <div className="cr-benefit-card">
                            <div className="cr-icon-box"><Award size={24} /></div>
                            <h3>Continuous Growth</h3>
                            <p>Enhancement of skills with continuous support, training, and motivation.</p>
                        </div>
                        <div className="cr-benefit-card">
                            <div className="cr-icon-box"><Clock size={24} /></div>
                            <h3>Flexible Hours</h3>
                            <p>Adaptable working hours tailored to your personal and professional needs.</p>
                        </div>
                        <div className="cr-benefit-card">
                            <div className="cr-icon-box"><TrendingUp size={24} /></div>
                            <h3>Balanced Scorecard</h3>
                            <p>Professional growth guided by a structured and balanced approach.</p>
                        </div>
                        <div className="cr-benefit-card">
                            <div className="cr-icon-box"><Trophy size={24} /></div>
                            <h3>Performance Bonuses</h3>
                            <p>Attractive incentives and bonuses based on your performance and impact.</p>
                        </div>
                    </div>
                </div>

                {/* Interview Process - Timeline */}
                <div className="cr-section cr-process-section">
                    <h2 className="cr-section-title">Hiring Journey</h2>
                    <div className="cr-timeline-wrapper">
                        <div className="cr-timeline">
                            {steps.map((step, index) => (
                                <div className="cr-timeline-item" key={index}>
                                    <div className="cr-timeline-marker">
                                        <div className="cr-timeline-circle">
                                            {step.icon}
                                        </div>
                                    </div>
                                    <div className="cr-timeline-content">
                                        <span className="cr-step-num">Step {index + 1}</span>
                                        <h4>{step.title}</h4>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Apply / Contact Section */}
                <div className="cr-apply-section">
                    <div className="cr-apply-card">
                        <div className="cr-apply-image">
                            <img src='https://res.cloudinary.com/drevfgyks/image/upload/v1725192789/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/illustration-folder-with-document_amptfi.png' alt="Apply" />
                        </div>
                        <div className="cr-apply-content">
                            <h2>Ready to Apply?</h2>
                            <p>Send your resume and portfolio to our HR team directly. We are always looking for talent.</p>

                            <div className="cr-contact-contacts">
                                <div className="cr-contact-row">
                                    <Mail className="cr-contact-icon" size={20} />
                                    <span>amaravathinatural@gmail.com</span>
                                </div>
                                <div className="cr-contact-row">
                                    <Phone className="cr-contact-icon" size={20} />
                                    <span>+91 98666 72765</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="cr-footer-tag">Emerging Farmers Empowerment</div>

            </div>
        </div>
    );
};

export default Career;
